import { Category, Type } from '@src/main/modules/parameters/domain/issues/category.interface';
import Categories from '@src/main/modules/parameters/ui/issues/components/Categories';
import Subtypes from '@src/main/modules/parameters/ui/issues/components/Subtypes';
import Types from '@src/main/modules/parameters/ui/issues/components/Types';
import ContentCard from '@src/main/shared/ui/components/card/ContentCard';
import HeaderTitle from '@src/main/shared/ui/components/header/HeaderTitle';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Issues.module.scss';

const Issues: FC = () => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [selectedType, setSelectedType] = useState<Type | null>(null);

  return (
    <ContentCard>
      <HeaderTitle title={t('parameters.issues.title')} />
      <div className={styles['grid-container']}>
        <Categories
          selectedCategory={selectedCategory}
          onSelectCategory={setSelectedCategory}
          resetType={() => setSelectedType(null)}
        />

        {selectedCategory && (
          <Types
            categoryId={selectedCategory.categoryId!}
            selectedCategory={selectedCategory}
            selectedType={selectedType}
            onSelectType={setSelectedType}
          />
        )}

        {selectedType && (
          <Subtypes
            typeId={selectedType.typeId!}
            selectedType={selectedType}
            selectedSubtype={null}
          />
        )}
      </div>
    </ContentCard>
  );
};

export default Issues;
